/**
 * Round a number to 2 decimal places. Use for commission, tax, and currency calculations
 * to avoid floating-point precision issues.
 * @param {number} n - Value to round
 * @returns {number} Value rounded to 2 decimals
 */
export function roundTo2(n) {
  if (typeof n !== "number" || Number.isNaN(n)) return 0;
  return Math.round(n * 100) / 100;
}

/**
 * Round to 2 decimals and return as formatted string (e.g. "1234.56").
 * @param {number} n - Value to round
 * @returns {string} Value as string with 2 decimal places
 */
export function roundTo2Str(n) {
  return roundTo2(n).toFixed(2);
}

/**
 * Trade record sheet: format a stored percent value (number or string) as "12.34%" or "-".
 */
export function formatPercentDisplayForSheet(value) {
  if (value === undefined || value === null || value === "") return "-";
  const n =
    typeof value === "number"
      ? value
      : parseFloat(String(value).trim().replace(/%/g, ""));
  if (!Number.isFinite(n)) return "-";
  return `${roundTo2(n)}%`;
}
